import styled from 'styled-components/macro';

export const CheckRowContainer = styled.div`
  margin: 5px 0;
  padding: 0 16px;
  vertical-align: middle;
`;
